import React from 'react';

export default class ReportDocuments extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className={'report-documents'}>
        <div className={'report-documents-heading'}>
          {this.props.pageNo === '3' ? 'IDENTITY CARD' : 'IMAGE UPLOADED FOR FACE MATCH'}
        </div>
        <div className={'report-documents-body'}>
          <div className={'document'}>
            <div className={'document-img'}>
              <img src={this.props.document1} />
            </div>
            {this.props.pageNo === '3' ? (
              <div className={'document-title'}>{'FRONT'}</div>
            ) : (
              <div></div>
            )}
          </div>
          {this.props.document2 !== null ? (
            <div className={'document'}>
              <div className={'document-img'}>
                <img src={this.props.document2} />
              </div>
              <div className={'document-title'}>{'BACK'}</div>
            </div>
          ) : (
            <div></div>
          )}
        </div>
      </div>
    );
  }
}

ReportDocuments.defaultProps = {
  document1: null,
  document2: null,
  pageNo: null
};
